module.exports = __webpack_public_path__ + "static/media/E-retirement-1024.f7665385.png";